export default "<div class=\"col-lg-12 text-center\">\n  <h3>Document is Loading, Please Wait</h3>\n  <i  class=\"fa fa-spinner fa-spin fa-2x\"></i>\n</div>\n"